const LandingPageStyles = {
    
    viewWidths: {
        mobile: 650,
        tablet: 1024
    },
    viewBreakpoints: {
        mobile: "max-width: 650px",
        tablet: "max-width: 1024px",
        desktop: "min-width: 1025px"
    },
    zIndices: {
        headerOverlay: "-1",
        landingLogo: "10",
        headerBackground: "20",
        headerText: "30"
    },
    grayFilter: 'rgba(70, 70, 80, .21)'
};
 
export default LandingPageStyles;


// WEBPACK FOOTER //
// ./src/styles/LandingPageStyles.js